const BILLING_COLORS: Record<string, { bg: string; color: string; label: string }> = {
  none: { bg: '#f1f5f9', color: '#64748b', label: 'None' },
  pending: { bg: '#dbeafe', color: '#1e40af', label: 'Pending' },
  claimed: { bg: '#fef3c7', color: '#92400e', label: 'Claimed' },
  invoiced: { bg: '#e0e7ff', color: '#3730a3', label: 'Invoiced' },
  paid: { bg: '#dcfce7', color: '#16a34a', label: 'Paid' },
  write_off: { bg: '#fee2e2', color: '#dc2626', label: 'Write-off' },
  denied: { bg: '#fce7f3', color: '#9d174d', label: 'Denied' },
}

export function BillingStatusBadge({ status }: { status: string }) {
  const entry = BILLING_COLORS[status] ?? BILLING_COLORS.none
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 12,
        fontSize: '0.75rem',
        fontWeight: 600,
        backgroundColor: entry.bg,
        color: entry.color,
      }}
    >
      {entry.label}
    </span>
  )
}
